
<div  *ngIf="!showUserData">
  <div class="outside-container mt-4">
    <div class="box-container ">
     <div class="container">
  <mat-progress-bar mode="indeterminate"></mat-progress-bar>
  </div></div></div>

</div>
<span *ngIf="showUserData">
<div class="outside-container mt-4">
    <div class="box-container ">
     <div class="container">
     <div class="title ">
        
        <div class="row">
          <div class=" col-md-5  " ><div  class="pointer d-flex justify-content-start "  (click)="backClick()" style="padding-left:20px;"><span >⬅️</span></div></div>  
         <div class="col-md-7 d-flex justify-content-start">User Detail</div>
        </div>
        </div>
        
     <form  [formGroup]="userinfoFg" autocomplete="off"  class=" row mt-4"  >
       
              <mat-form-field class=" required col-md-3 form-group " appearance="outline">
                <mat-label>Name</mat-label>
                <input matInput  type="text" required maxlength="250" formControlName="name" name="name" autocomplete="off"  >
                <small *ngIf="userinfoFg.controls['name'].dirty && userinfoFg.controls['name'].invalid" class="warn">Please enter Name!</small>
              </mat-form-field>
            
             
              <!-- <mat-form-field class=" required col-md-3 form-group " appearance="outline">
                <mat-label>Email Id</mat-label>
                <input matInput  type="text" required id="inputname" readonly formControlName="email" name="email" autocomplete="off"  >
                <small *ngIf="userinfoFg.controls['email'].dirty && userinfoFg.controls['email'].invalid" class="warn">Please Enter Valid Email Id!</small>
              </mat-form-field> -->
              <mat-form-field class="required col-md-3 form-group" appearance="outline">
  <mat-label>Email Id</mat-label>
  
  <input
    matInput
    type="text"
    required
    id="inputname"
    formControlName="email"
    name="email"
    autocomplete="off"
  />

  <!-- Button inside mat-form-field -->
  <button
    mat-icon-button
    matSuffix
    aria-label="Edit Email"
    (click)="onEditEmail()"
  >
    <mat-icon>edit</mat-icon>
  </button>

  <!-- Error message -->
  <small
    *ngIf="userinfoFg.controls['email'].dirty && userinfoFg.controls['email'].invalid"
    class="warn"
  >
    Please Enter Valid Email Id!
  </small>
</mat-form-field>
                <mat-form-field class=" col-md-3 form-group " appearance="outline">
                  <mat-label>Mobile Number</mat-label>
                  <input matInput type="text" formControlName="mobile" (keypress)="onlyNumberKey($event)" name="mobileNumber" autocomplete="off" >
                  <small *ngIf="userinfoFg.controls['mobile'].dirty && userinfoFg.controls['mobile'].invalid" class="warn">Please Enter Valid Mobile Number !</small>

                </mat-form-field>
                <mat-form-field *ngIf="userData.userType==='STAFF'" class="col-md-3 form-group " appearance="outline">
                  <mat-label>Account Code</mat-label>

                  <input matInput type="text" maxlength="30" formControlName="accountCode" name="accountCode" autocomplete="off" >
                    <!-- <mat-select  matNativeControl name="company"  formControlName="status"   >
                      <mat-option  value="ENABLE" >Active</mat-option>
                      <mat-option  value="DISABLE" >Inactive</mat-option>
                    </mat-select> -->
                   </mat-form-field>
                   <mat-form-field *ngIf="loginUserType==='STAFF'&&privilegesView==='VAMD'" class="col-md-3 form-group " appearance="outline" >
                    <mat-label>User Role</mat-label>
                    <mat-select  multiple    name="roleId" formControlName="roleId" >
                     
                      <mat-option  *ngFor="let role of roleList" [value]="role.roleId">{{role.roleName}}</mat-option>
        
                  </mat-select>
            <!-- <input matInput type="text"   maxlength="35"  formControlName="roleId" name="roleId" autocomplete="off" > -->

                  </mat-form-field> 
                   
                   <mat-form-field *ngIf="userData.userType==='CORPORATE'&&loginUserType==='STAFF'" class="col-md-3 form-group " appearance="outline">
                                                     
                    <mat-label>Branch Id</mat-label>
                    <mat-select    name="branchId" formControlName="branchId">
                      <mat-option *ngFor="let item of branchData" [value]="item.branchCode">{{item?.city}}</mat-option>
            

                  </mat-select>
                    <!-- <input matInput type="text"   maxlength="35"  formControlName="branchId" name="branchId" autocomplete="off" > -->
                    </mat-form-field>   
                    <mat-form-field  *ngIf="userData.userType==='STAFF'" class="col-md-3 form-group " appearance="outline">
                                                     
                      <mat-label>Branch Id</mat-label>
                      <mat-select  multiple  name="branchId" formControlName="branchId">
                        <mat-option *ngFor="let item of branchData" [value]="item.branchCode">{{item?.city}}</mat-option>
              
  
                    </mat-select>
                      <!-- <input matInput type="text"   maxlength="35"  formControlName="branchId" name="branchId" autocomplete="off" > -->
                      </mat-form-field>   

                      <mat-form-field *ngIf="userData.userType==='STAFF'" class="col-md-3 form-group " appearance="outline">
                                                     
                        <mat-label>Tenants</mat-label>
                        <mat-select   matNativeControl name="tenants"  formControlName="whitelabelId" >
                          <mat-option  [value]="0" >All</mat-option>
                          <mat-option *ngFor="let tenants of tenantsList" [value]="tenants.id" >{{tenants.code}}</mat-option>

                        </mat-select>
                        </mat-form-field>
                        <mat-form-field *ngIf="userData.userType==='CORPORATE'&&loginUserType==='STAFF'" class="col-md-3 form-group " appearance="outline">
                                                     
                          <mat-label>Business Group</mat-label>
                          <mat-select-trigger (click)="businessGrp.open()">
                            <input (input)="businessGrp.open()" matInput   placeholder="Search ..." [(ngModel)]="searchBusinessQuery" [ngModelOptions]="{standalone: true}" (ngModelChange)="filterBusinessEntities()" />
                          </mat-select-trigger>
                          <mat-select #businessGrp="matSelect"   matNativeControl name="businessGroup"  formControlName="businessGroupCode" >
                            <mat-option *ngFor="let group of filteredBusinessGroup" [value]="group.code" >{{group.name}}</mat-option>

                          </mat-select>
                          </mat-form-field>  

                          <div *ngIf="loginUserType==='STAFF'" class="col-md-3 form-group  " >
                           <div class="col-md-12 d-flex justify-content-start">
                            <input type="checkbox" name="emailAllowed" style="cursor: pointer;margin-right: 6px;height: 15px;width: 15px;" formControlName="emailAllowed" />
                            <span style="color: #666666;" >Email Allowed</span>
                          </div>
                          <div class="col-md-12 d-flex justify-content-start mt-1">
                            <input type="checkbox" name="ticket" style="cursor: pointer;margin-right: 6px;height: 15px;width: 15px;" formControlName="showTicketPricing"/>
                             <span style="color: #666666;">Enable Ticket Pricing</span>
                             </div>
                             <div class="col-md-12 d-flex justify-content-start mt-1">
                              <input type="checkbox" name="personalBooking" style="cursor: pointer;margin-right: 6px;height: 15px;width: 15px;" formControlName="personalBookingAllowed"/>
                               <span style="color: #666666;">Allow Personal Booking</span>
                               </div>
                            </div> 
                            <!-- <div *ngIf="loginUserType==='STAFF'" class="col-md-3 form-group mt-1" >
                            

                              </div>   -->
                
          </form>
          <div class="d-flex justify-content-end">
            <button *ngIf="!disableInfosave" class="btn btn-outline-success c-width-100px shadow " (click)="updateUserInfo()" [disabled]="userinfoFg.invalid">Update</button>
            <button *ngIf="disableInfosave" class="btn btn-outline-success c-width-100px shadow "  [disabled]="true">Update</button>
        </div>
     </div> 
    </div></div>

    <div  class="outside-container mt-4">
      <div class="box-container ">
       <div class="container">
       <div class="title "> 
        <div class="row">
          <div class=" col-md-5  d-flex justify-content-start" style="padding-left:30px;" > <mat-icon *ngIf="!showCard" class="mt-2 pointer" (click)="OnClickCard()">add</mat-icon> <mat-icon *ngIf="showCard" class="mt-2 pointer" (click)="OnClickCard()">remove</mat-icon></div>  
    
         <div class="col-md-7 d-flex justify-content-start">Card Details</div>
    
        </div>
      </div>
       <form *ngIf="showCard" [formGroup]="userCardFg" autocomplete="off"  class=" row mt-4"  >
         
                <mat-form-field class=" required col-md-4 form-group " appearance="outline">
                  <mat-label>Card Type</mat-label>
                  <mat-select matNativeControl name="cardType" formControlName="cardType" (selectionChange)="changeCardType($event)">
                    <mat-option *ngFor="let card of cardtypedata"  [value]="card">{{card}}</mat-option>

                  </mat-select>  
                </mat-form-field>
              
               
                <mat-form-field class=" required col-md-4 form-group " appearance="outline">
                  <mat-label>Bank Name</mat-label>
                  <mat-select matNativeControl name="bankName" formControlName="bankName">
                    <mat-option *ngFor="let bank of bankdata"  [value]="bank">{{bank}}</mat-option>

                  </mat-select>  
                </mat-form-field>
             
                  <mat-form-field class=" col-md-4 required form-group " appearance="outline">
                    <mat-label>Card Number</mat-label>
                    <input matInput type="text"  name="cardNumber" autocomplete="off" formControlName="cardNumber" [minlength]="CardLenght" [maxlength]="CardLenght" (keypress)="onlyNumberKey($event)">
                    <small *ngIf="userCardFg.controls['cardNumber'].dirty && userCardFg.controls['cardNumber'].invalid" class="warn">Please Enter Valid Card Number!</small>

                  </mat-form-field>
                  <mat-form-field class=" col-md-4  required form-group " appearance="outline">
                    <mat-label>Name of Card</mat-label>
                    <input matInput type="text"   name="cardHolder" autocomplete="off" formControlName="holderName">
                    <small *ngIf="userCardFg.controls['holderName'].dirty && userCardFg.controls['holderName'].invalid" class="warn">Please Enter Card Holder Name!</small>

                  </mat-form-field>
                  <mat-form-field class=" col-md-4  required form-group " appearance="outline">
                    <mat-label>Expiry Card (MM/YYYY)</mat-label>
                                              <input matInput type="text"  name="expiryDate" autocomplete="off" formControlName="expiryDate" >
                                              <small *ngIf="userCardFg.controls['expiryDate'].dirty && userCardFg.controls['expiryDate'].invalid" class="warn">Please Enter Expiry Date!</small>
  
                  </mat-form-field>
                 
                 
                  
                 
                  <label style="display: flex; align-items: flex-start;">
                    <input type="checkbox"  [(ngModel)]="cardVerification" [ngModelOptions]="{standalone: true}" style="margin-right: 8px; margin-top: 4px; width: 15px;height: 15px;cursor: pointer;" />
                    <span style="font-family:'Gill Sans', 'Gill Sans MT', Calibri, 'Trebuchet MS', sans-serif;">
                      I provide my consent to save my corporate credit card/commercial card for use to issue GDS-based transactions and to generate and save the token for future transactions.
                    </span>
                  </label>
                  
            </form>
            <div *ngIf="showCard" class="d-flex justify-content-center ">
              <button  class="btn btn-outline-success c-width-100px shadow "  (click)="AddCreditCard()" [disabled]="disabledCards()" >Add Card</button>

          </div>
            <div *ngIf="showCard"  class="  col-md-12 mt-2 float-right mt-0 ml-2 mb-1 mr-0 pl-0 pr-0 mt-0" style="height: auto; max-height: 200px ;overflow: auto;">
                      
              <table class=" cardTable "
                style="overflow-y:scroll;height: auto; width: 100%;">
                <thead class="thead-light" >
                  <tr>
                    <th class="small font-weight-bold w-20 small" style="width: 180px;">Card Type</th>
    
                    <th class="small font-weight-bold w-20 small" style="width: 180px;">Bank Name</th>
                    <th class="small font-weight-bold w-20 small" style="width: 180px;">Card Number</th>
                    <th class="small font-weight-bold w-40 small" style="width: 180px;" >Name of Card</th>
                    <th class="small font-weight-bold w-40 small" style="width: 180px;" >Expiry Card</th>
                    <th class="small font-weight-bold w-20 " style="width: 180px;">Action</th>
    
    
    
                  </tr>
                </thead>
                <tbody >
                <!--<tr *ngFor="let item of energy.value; let i=index" (dblclick)="dblclick(item)" class="pointer">-->
                  <tr *ngFor="let item of  this.CreditData; let i=index" style="height: 25px; ">
                    <td class="small  mb-0 mt-0 pl-0 pb-0 " >{{item?.cardType||"-"}}</td>
                    <td class="small  mb-0 mt-0 pl-0 pb-0" >{{item?.bankName||"-"}}</td>
                    <td class="small  mb-0 mt-0 pl-0 pb-0" >{{item?.maskedCardNumber||"-"}}</td>
                    <td class="small  mb-0 mt-0 pl-0 pb-0" >{{item?.holderName||"-"}}</td>
                    <td class="small  mb-0 mt-0 pl-0 pb-0" >{{item?.expiryDate||"-"}}</td>
                    <td class="small  mb-0 mt-0 pl-0 pb-0" >
                      <button *ngIf="!item.tokenized" class="btn btn-outline-success c-width-100px shadow mt-1 mb-2"  (click)="JusPayLink(item)"> Tokenized This </button>
                      <button *ngIf="item.tokenized" class="btn btn-outline-success c-width-100px shadow mt-1 mb-2" disabled > Tokenized  </button>
                      <!-- <img src="../../../assets/images/crosss.png" style="width: 20px;margin-left: 6px; cursor: pointer;" (click)="removeCard()"  > -->

                      </td>
    
                   
                  
                  </tr>
                </tbody>
              </table>
              <!-- <div  *ngIf="showGst" class="d-flex justify-content-end mt-4">
                <button *ngIf="!disableGstsave" class="btn btn-outline-success c-width-100px shadow " (click)="updateGstUser()">Update</button>
                <button *ngIf="disableGstsave" class="btn btn-outline-success c-width-100px shadow "  [disabled]="true">Update</button>
            </div> -->
              </div>
           
       </div> 
      </div></div>   



<div *ngIf="!userType" class="outside-container mt-4">
  <div class="box-container ">
   <div class="container">
   <div class="title "> 
    <div class="row">
      <div class=" col-md-5  d-flex justify-content-start" style="padding-left:30px;" > <mat-icon *ngIf="!showGst" class="mt-2 pointer" (click)="OnClickGst()">add</mat-icon> <mat-icon *ngIf="showGst" class="mt-2 pointer" (click)="OnClickGst()">remove</mat-icon></div>  

     <div class="col-md-7 d-flex justify-content-start">GST Detail</div>

    </div>
  </div>
   <form *ngIf="showGst" [formGroup]="userGstFg" autocomplete="off" (ngSubmit)="updateGstUser()" class=" row mt-4"  >
     
            <mat-form-field class=" required col-md-4 form-group " appearance="outline">
              <mat-label>GST Number</mat-label>
              <input matInput  type="text" required  formControlName="gstNumber" name="gstNumber" autocomplete="off"  >
              <small *ngIf="userGstFg.controls['gstNumber'].dirty && userGstFg.controls['gstNumber'].invalid" class="warn">Please enter GST Number!</small>
            </mat-form-field>
          
           
            <mat-form-field class=" required col-md-4 form-group " appearance="outline">
              <mat-label>GST Email</mat-label>
              <input matInput  type="text" required   formControlName="gstHolderEmail" name="gstHolderEmail" autocomplete="off"  >
              <small *ngIf="userGstFg.controls['gstHolderEmail'].dirty && userGstFg.controls['gstHolderEmail'].invalid" class="warn">Please Enter Valid Email Id !</small>

            </mat-form-field>
              <mat-form-field class=" col-md-4 required form-group " appearance="outline">
                <mat-label>GST Name</mat-label>
                <input matInput type="text" required formControlName="gstHolderName" name="gstHolderName" autocomplete="off" >
                <small *ngIf="userGstFg.controls['gstHolderName'].dirty && userGstFg.controls['gstHolderName'].invalid" class="warn">Please Enter Gst Name !</small>

              </mat-form-field>
              <mat-form-field class=" col-md-4  required form-group " appearance="outline">
                <mat-label>GST Phone No</mat-label>
                <input matInput type="text" required formControlName="gstPhone" name="gstPhone" autocomplete="off" >
                <small *ngIf="userGstFg.controls['gstPhone'].dirty && userGstFg.controls['gstPhone'].invalid" class="warn">Please Enter Valid Phone Number !</small>

              </mat-form-field>
              <mat-form-field class=" col-md-4 required form-group " appearance="outline">
                <mat-label>GST Address</mat-label>
                <input matInput type="text" required formControlName="gstAddress" name="gstAddress" autocomplete="off" >
                <small *ngIf="userGstFg.controls['gstAddress'].dirty && userGstFg.controls['gstAddress'].invalid" class="warn">Please Enter Gst Address !</small>

              </mat-form-field>
             
              
             
                
              
        </form>
        <div *ngIf="showGst" class="d-flex justify-content-center ">
          <button class="btn btn-outline-success c-width-100px shadow " (click)="submitGst()" [disabled]="userGstFg.invalid" >Add GST Detail</button>
      </div>
        <div *ngIf="!disableGstsave" class="  col-md-12 mt-2 float-right mt-0 ml-2 mb-1 mr-0 pl-0 pr-0 mt-0" style="height: auto; max-height: 200px ;overflow: auto;">
                  
          <table class="table table-sm table-striped table-bordered c-table-hover ml-0 mr-0 mb-0 mt-0"
            style="overflow-y:scroll;height: auto; width: 100%;">
            <thead class="thead-light" >
              <tr>
                <th class="small font-weight-bold w-20 small" style="width: 180px;">Gst Number</th>

                <th class="small font-weight-bold w-20 small" style="width: 180px;">Gst Email</th>
                <th class="small font-weight-bold w-20 small" style="width: 180px;">Gst Name</th>
                <th class="small font-weight-bold w-40 small" style="width: 180px;" >Gst Phone No</th>
                <th class="small font-weight-bold w-40 small" style="width: 180px;" >Gst Address</th>
                <!--<th class="small font-weight-bold w-20 " style="width: 180px;">Gst State Code</th>-->



              </tr>
            </thead>
            <tbody >
            <!--<tr *ngFor="let item of energy.value; let i=index" (dblclick)="dblclick(item)" class="pointer">-->
              <tr *ngFor="let item of gstvalue; let i=index" style="height: 25px; ">
                <td class="small  mb-0 mt-0 pl-0 pb-0" >{{item.gstNumber}}</td>
                <td class="small  mb-0 mt-0 pl-0 pb-0" >{{item.gstHolderEmail}}</td>
                <td class="small  mb-0 mt-0 pl-0 pb-0" >{{item.gstHolderName}}</td>
                <td class="small  mb-0 mt-0 pl-0 pb-0" >{{item.gstPhone}}</td>
                <td class="small  mb-0 mt-0 pl-0 pb-0" >{{item.gstAddress}}</td>
                <!-- <td class="small  mb-0 mt-0 pl-0 pb-0" >{{item.gstCode}}</td> -->

               
              
              </tr>
            </tbody>
          </table>
          <div  *ngIf="showGst" class="d-flex justify-content-end mt-4">
            <button *ngIf="!disableGstsave" class="btn btn-outline-success c-width-100px shadow " (click)="updateGstUser()">Update</button>
            <button *ngIf="disableGstsave" class="btn btn-outline-success c-width-100px shadow "  [disabled]="true">Update</button>
        </div>
          </div>
       
   </div> 
  </div></div>
<!--#########################################################################-->

<div class="outside-container mt-4">
  <div class="box-container ">
   <div class="container">
   <div class="title ">
      
      <div class="row">
        <div class=" col-md-5  " ></div>  
       <div class="col-md-7 d-flex justify-content-start">Contact Detail</div>
      </div>
      </div>
      
   <form  [formGroup]="contactinfoFg" autocomplete="off" (ngSubmit)="updateContactUser()" class=" row mt-4"  >

    <mat-form-field class="col-md-3 form-group required" appearance="outline">
      <mat-label for="addressCountry" >Country</mat-label>
      <input matInput type="text" [matAutocomplete]="autoCountry" [formControl]="addressCountryFormControl">
      <mat-autocomplete #autoCountry="matAutocomplete" [displayWith]="displayCountrySelectionFn">
          <mat-option *ngFor="let option of countryFilteredOptions | async" [value]="option">
              {{option.countryName}}
          </mat-option>
      </mat-autocomplete>
      <mat-error>Please select correct country</mat-error>
  </mat-form-field>
  <mat-form-field class="col-md-3 form-group required" appearance="outline">
      <mat-label for="addressState">State</mat-label>
      <ng-container *ngIf="addressCountryFormControl?.value?.countryCode=='IN'" >
          <input matInput type="text" [matAutocomplete]="autoState" [formControl]="addressStateFormControl">
          <mat-autocomplete 
                      #autoState="matAutocomplete" [displayWith]="displayStateSelectionFn">
              <mat-option *ngFor="let option of stateFilteredOptions | async" [value]="option">
                  {{option.stateName}}
              </mat-option>
          </mat-autocomplete>
      </ng-container>
      <ng-container *ngIf="addressCountryFormControl?.value?.countryCode !='IN'">
          <input matInput type="text"  formControlName="stateText">
      </ng-container>
  </mat-form-field>
  <mat-form-field class="col-md-3 form-group required" appearance="outline">
      <mat-label for="addressCity">City</mat-label>
      <ng-container *ngIf="addressCountryFormControl?.value?.countryCode=='IN'" >
          <input matInput type="text" [matAutocomplete]="autoCity" [formControl]="addressCityFormControl">
          <mat-autocomplete 
                      #autoCity="matAutocomplete">
              <mat-option *ngFor="let option of cityFilteredOptions | async" [value]="option">
                  {{option}}
              </mat-option>
          </mat-autocomplete>
      </ng-container>
      <ng-container *ngIf="addressCountryFormControl?.value?.countryCode !='IN'">
          <input matInput type="text"  [formControl]="addressCityFormControl">
      </ng-container>
  </mat-form-field>
  <mat-form-field class="col-md-3 form-group required" appearance="outline">
      <mat-label for="addressPostalCode">Pincode</mat-label>
      <input matInput type="text" [formControl]="postalCodeFormCountol">
  </mat-form-field>

            <mat-form-field class=" required col-md-3 form-group " appearance="outline">
              <mat-label>Street</mat-label>
              <input matInput  type="text" required  formControlName="street" name="street" autocomplete="off"  >
            </mat-form-field>
          
              <mat-form-field class=" col-md-3 form-group " appearance="outline">
                <mat-label>Phone</mat-label>
                <input matInput type="text" formControlName="phone" name="phone" autocomplete="off" >
              </mat-form-field>
              <mat-form-field class=" required col-md-3 form-group " appearance="outline">
                <mat-label>CC Emails</mat-label>
                <input matInput  type="text" required   formControlName="ccEmails" name="ccEmail" autocomplete="off"  >
              </mat-form-field>
               
             

             
              
        </form>
        <div class="d-flex justify-content-end">
          <button *ngIf="!disableContactsave" class="btn btn-outline-success c-width-100px shadow " (click)="updateContactUser()" [disabled]="contactinfoFg.invalid">Update</button>
          <button *ngIf="disableContactsave" class="btn btn-outline-success c-width-100px shadow "  [disabled]="true">Update</button>
      </div>
   </div> 
  </div></div>



  <div *ngIf="userType" class="outside-container mt-4">
    <div class="box-container ">
     <div class="container">
     <div class="title "> 
      <div class="row">
        <div class=" col-md-5  d-flex justify-content-start" style="padding-left:30px;" > <mat-icon *ngIf="!showOrganization" class="mt-2 pointer" (click)="OnClickOrg()">add</mat-icon> <mat-icon *ngIf="showOrganization" class="mt-2 pointer" (click)="OnClickOrg()">remove</mat-icon></div>  
       <div class="col-md-7 d-flex justify-content-start">Organizational Details</div>
      </div>
    </div>
     <form *ngIf="showOrganization"  [formGroup]="profileFg" autocomplete="off"  class=" row mt-4"  >
       
              <mat-form-field class="  col-md-3 form-group " appearance="outline">
                <mat-label>Employee Code</mat-label>
                <input matInput  type="text"   name="employeeCode"  autocomplete="off" formControlName="employeeCode" >
              </mat-form-field>
            
             
              <mat-form-field class="  col-md-3 form-group " appearance="outline">
                <mat-label>Designation</mat-label>
                <input matInput  type="text"     name="designation" autocomplete="off" formControlName="designation" >
  
              </mat-form-field>
                <mat-form-field class=" col-md-3  form-group " appearance="outline" >
                  <mat-label>Band</mat-label>
                  <input matInput  type="text"     name="band" autocomplete="off" formControlName="band" >

                  <!-- <mat-select  matNativeControl name="band" formControlName="band" >
                  </mat-select>   -->
                </mat-form-field>
                <mat-form-field class=" col-md-3   form-group " appearance="outline">
                  <mat-label>Location</mat-label>

                  <input matInput  type="text"     name="location" autocomplete="off" formControlName="location" >

                  <!-- <mat-select  matNativeControl name="location"    formControlName="location">
                  </mat-select>   -->
                </mat-form-field>
                <mat-form-field class=" col-md-3 required form-group " appearance="outline">
                  
                  <mat-label>Department</mat-label>
                  <input matInput  type="text"     name="department" autocomplete="off" formControlName="department" >

                  <!-- <mat-select  matNativeControl name="department"   formControlName="department" >
                  </mat-select>   -->
                </mat-form-field>
               
                <mat-form-field class=" col-md-3 required form-group " appearance="outline">
                  
                  <mat-label>Cost Center</mat-label>
                  <input matInput  type="text"     name="costCenter" autocomplete="off" formControlName="costCenter" >

                  <!-- <mat-select  matNativeControl name="department"   formControlName="department" >
                  </mat-select>   -->
                </mat-form-field>
                <mat-form-field class=" col-md-3 required form-group " appearance="outline">
                  
                  <mat-label>Project Code</mat-label>
                  <input matInput  type="text"     name="projectCode" autocomplete="off" formControlName="projectCode" >

                  <!-- <mat-select  matNativeControl name="department"   formControlName="department" >
                  </mat-select>   -->
                </mat-form-field>
               
                  
                <mat-form-field class="col-md-3 form-group " appearance="outline">
                  <mat-label> Meta Info 2 </mat-label>
                  <input matInput  type="text"     name="metaInfo" autocomplete="off" formControlName="metaInfo" >

                    <!-- <mat-select  matNativeControl name="meta2"   formControlName="metaInfo" >
                    </mat-select> -->
                   </mat-form-field>
                  
                   <mat-form-field class="col-md-3 form-group " appearance="outline">
                    <mat-label> Domestic Eligibility	 </mat-label>
                      <mat-select  matNativeControl name="Deligibility"  formControlName="domesticEligibility"  >
                          <mat-option value="" selected="selected">--</mat-option>
                          <mat-option value="G">Lowest Economy</mat-option>
                          <mat-option value="R">Refundable Economy</mat-option>
                          <mat-option value="E">Fullfare Economy</mat-option>
                          <mat-option value="B">Business</mat-option>
                      </mat-select>
                     </mat-form-field>
                     <mat-form-field class=" col-md-3 required form-group " appearance="outline">
                      <mat-label>International Eligibility</mat-label>
                      <mat-select  matNativeControl name="InEligibility"   formControlName="internationalEligibility" >
                          <mat-option value="" selected="selected">--</mat-option>
                          <mat-option value="E">Economy</mat-option>
                          <mat-option value="B">Business</mat-option>
                          <mat-option value="F">First</mat-option>
                      </mat-select>      
                    </mat-form-field>
                   
                    <mat-form-field class=" col-md-3  form-group " appearance="outline">
                      <mat-label>Is Approver</mat-label>
                      <!-- <input matInput type="text"  name="HolderName" autocomplete="off"  > -->
                      <mat-select  matNativeControl name="approver"   formControlName="approver" >
                        <mat-option value="true">True</mat-option>
                        <mat-option value="false">False</mat-option>
                    </mat-select>   
                    </mat-form-field>
                    <mat-form-field class=" col-md-3  form-group " appearance="outline">
                      <mat-label>Approver Credit Limit</mat-label>
                      <input matInput type="text" (keypress)="onlyNumberKey($event)" name="creditLimit" autocomplete="off" formControlName="approvalLimit">
      
                    </mat-form-field>
                    <mat-form-field class="col-md-3 " appearance="outline">
                      <mat-label>Date Of Joining</mat-label>
                      <input matInput [matDatepicker]="pickers" formControlName="dateOfJoining">

                      <mat-datepicker-toggle matIconSuffix [for]="pickers"></mat-datepicker-toggle>
                      <mat-datepicker #pickers></mat-datepicker>
                  </mat-form-field>
                  <mat-form-field class="col-md-3 " appearance="outline">
                    <mat-label>Date Of Termination</mat-label>
                    <input matInput [matDatepicker]="picker" formControlName="dateOfTermination">

                    <mat-datepicker-toggle matIconSuffix [for]="picker"></mat-datepicker-toggle>
                    <mat-datepicker #picker></mat-datepicker>
                </mat-form-field>
                    <mat-form-field class="col-md-3 form-group " appearance="outline">
                      <mat-label>Billing Entity</mat-label>
            <mat-select-trigger (click)="autoBill.open()">
              <input (input)="autoBill.open()" matInput   placeholder="Search ..." [(ngModel)]="searchQuery" [ngModelOptions]="{standalone: true}" (ngModelChange)="filterEntities()" />
            </mat-select-trigger>
            <mat-select #autoBill="matSelect"  matNativeControl name="entity"   autocomplete="off" formControlName="billingEntity">
              <mat-option *ngFor="let item of filteredEntities"     [value]="item?.entityRefId" >{{item?.entityName}}</mat-option>
            </mat-select>
    
                       </mat-form-field>

                       <mat-form-field *ngIf="loginUserType==='STAFF'||loginUserType==='CORPORATE'" class="col-md-3 form-group " appearance="outline">
                        <mat-label>Approver List</mat-label>
              <mat-select-trigger (click)="autoApprover.open()">
                <input (input)="autoApprover.open()" matInput   placeholder="Search ..." [(ngModel)]="searchUserQuery" [ngModelOptions]="{standalone: true}" (ngModelChange)="filterCorporateUsers()" />
              </mat-select-trigger>
              <mat-select multiple #autoApprover="matSelect"  matNativeControl name="approverList"   autocomplete="off" formControlName="supervisorCodes">
                <mat-option *ngFor="let item of filteredCorporateUsers"     [value]="item?.userUid" >{{item?.userBookingProfile?.firstName +'-'+item?.userBookingProfile?.username}}</mat-option>
              </mat-select>
      
                         </mat-form-field>
                    

          </form>
          <div *ngIf="showOrganization" class="d-flex justify-content-end mt-2">
            <button  class="btn btn-outline-success c-width-100px shadow " (click)="updateProfileUser()" >Save</button>
        </div>
          </div> </div> </div>





          <div *ngIf="userType" class="outside-container mt-4">
            <div class="box-container ">
             <div class="container">
             <div class="title "> 
              <div class="row">
                <div class=" col-md-5  d-flex justify-content-start" style="padding-left:30px;" > <mat-icon *ngIf="!this.showReporting" class="mt-2 pointer" (click)="OnClickRepo()">add</mat-icon> <mat-icon *ngIf="showReporting" class="mt-2 pointer" (click)="OnClickRepo()">remove</mat-icon></div>  
               <div class="col-md-7 d-flex justify-content-start">Reporting Details</div>
              </div>
            </div>
             <form *ngIf="showReporting"  [formGroup]="profileFg" autocomplete="off"  class=" row mt-4"  >
                <div formGroupName="reportingDetails" class="row">
              
                  <div class="col-md-3 form-group">
                    <mat-form-field appearance="outline" class="w-100">
                      <mat-label>Fare Option 1</mat-label>
                      <input matInput formControlName="fareOption1" />
                    </mat-form-field>
                  </div>
              
                  <div class="col-md-3 form-group">
                    <mat-form-field appearance="outline" class="w-100">
                      <mat-label>Fare Option 2</mat-label>
                      <input matInput formControlName="fareOption2" />
                    </mat-form-field>
                  </div>
              
                  <div class="col-md-3 form-group">
                    <mat-form-field appearance="outline" class="w-100">
                      <mat-label>Fare Option 3</mat-label>
                      <input matInput formControlName="fareOption3" />
                    </mat-form-field>
                  </div>
              
                  <div class="col-md-3 form-group">
                    <mat-form-field appearance="outline" class="w-100">
                      <mat-label>Reference</mat-label>
                      <input matInput formControlName="reference" />
                    </mat-form-field>
                  </div>
              
                  <div class="col-md-3 form-group">
                    <mat-form-field appearance="outline" class="w-100">
                      <mat-label>IO PID No</mat-label>
                      <input matInput formControlName="ioPidNo" />
                    </mat-form-field>
                  </div>
              
                  <div class="col-md-3 form-group">
                    <mat-form-field appearance="outline" class="w-100">
                      <mat-label>Indent Doc No</mat-label>
                      <input matInput formControlName="indentDocNo" />
                    </mat-form-field>
                  </div>
              
                  <div class="col-md-3 form-group">
                    <mat-form-field appearance="outline" class="w-100">
                      <mat-label>Booked By</mat-label>
                      <input matInput formControlName="bookedBy" />
                    </mat-form-field>
                  </div>
              
                  
              
                  
                  <div class="col-md-3 form-group">
                    <mat-form-field appearance="outline" class="w-100">
                      <mat-label>Reason For Travel</mat-label>
                      <input matInput formControlName="reasonForTravel" />
                    </mat-form-field>
                  </div>
              
                  <div class="col-md-3 form-group">
                    <mat-form-field appearance="outline" class="w-100">
                      <mat-label>Missed Savings</mat-label>
                      <input matInput formControlName="missedSavings" />
                    </mat-form-field>
                  </div>
              
                  <div class="col-md-3 form-group">
                    <mat-form-field appearance="outline" class="w-100">
                      <mat-label>Global ID</mat-label>
                      <input matInput formControlName="globalId" />
                    </mat-form-field>
                  </div>
              
                  <div class="col-md-3 form-group">
                    <mat-form-field appearance="outline" class="w-100">
                      <mat-label>Fare Type</mat-label>
                      <input matInput formControlName="fareType" />
                    </mat-form-field>
                  </div>
              
                  <div class="col-md-3 form-group">
                    <mat-form-field appearance="outline" class="w-100">
                      <mat-label>Fare Restriction</mat-label>
                      <input matInput formControlName="fareRestriction" />
                    </mat-form-field>
                  </div>
              
                 
                  <div class="col-md-3 form-group">
                    <mat-form-field appearance="outline" class="w-100">
                      <mat-label>Cod1</mat-label>
                      <input matInput formControlName="cod1" />
                    </mat-form-field>
                  </div>
              
                  <div class="col-md-3 form-group">
                    <mat-form-field appearance="outline" class="w-100">
                      <mat-label>Cod2</mat-label>
                      <input matInput formControlName="cod2" />
                    </mat-form-field>
                  </div>
                  <div class="col-md-3 form-group">
                    <mat-form-field appearance="outline" class="w-100">
                      <mat-label>Cod3</mat-label>
                      <input matInput formControlName="cod3" />
                    </mat-form-field>
                  </div>
              
                  <div class="col-md-3 form-group">
                    <mat-form-field appearance="outline" class="w-100">
                      <mat-label>CFO Approval &lt; 7 Days</mat-label>
                      <input matInput formControlName="cfoApprovalLessThan7Days" />
                    </mat-form-field>
                  </div>
              
                  <div class="col-md-3 form-group">
                    <mat-form-field appearance="outline" class="w-100">
                      <mat-label>Billability</mat-label>
                      <input matInput formControlName="billability" />
                    </mat-form-field>
                  </div>
                  <div class="col-md-3 form-group">
                    <mat-form-field appearance="outline" class="w-100">
                      <mat-label>Sap Code</mat-label>
                      <input matInput formControlName="sapCode" />
                    </mat-form-field>
                  </div>
                  
              
                </div>
              
        
                  </form>
                  <div *ngIf="showReporting" class="d-flex justify-content-end mt-2">
                    <button  class="btn btn-outline-success c-width-100px shadow " (click)="updateProfileUser()" >Save</button>
                </div>
                  </div> </div> </div>







          <div *ngIf="userType" class="outside-container mt-4">
            <div class="box-container ">
             <div class="container">
             <div class="title "> 
              <div class="row">
                <div class=" col-md-5 "></div>  

               <div class="col-md-7 d-flex justify-content-start" style="margin-left:-80px">Personal Info (Details as per passport)</div>
              </div>
            </div>
             <form  [formGroup]="profileFg" autocomplete="off"  class=" row mt-4"  >
               
                      <mat-form-field class="  col-md-3 form-group " appearance="outline">
                        <mat-label>Title</mat-label>
                        <!-- <input matInput  type="text"   name="titel" autocomplete="off" formControlName="title" > -->
                        <mat-select  matNativeControl name="company"    formControlName="title">
                          <mat-option value="MR">Mr</mat-option>
                          <mat-option value="MRS">Mrs</mat-option>
                          <mat-option value="MS">Ms</mat-option>


                       </mat-select>
                      </mat-form-field>
                      <mat-form-field class="  col-md-3 form-group " appearance="outline">
                        <mat-label>Gender</mat-label>
                        <!-- <input matInput  type="text"   name="titel" autocomplete="off" formControlName="title" > -->
                        <mat-select  matNativeControl name="company"    formControlName="gender">
                          <mat-option value="M">Male</mat-option>
                          <mat-option value="F">Female</mat-option>
                          <mat-option value="T">Transgender</mat-option>


                       </mat-select>
                      </mat-form-field>
                    
                     
                      <mat-form-field class="  col-md-3 form-group " appearance="outline">
                        <mat-label>First Name	</mat-label>
                        <input matInput  type="text"     name="firstName" autocomplete="off" formControlName="firstName" >
          
                      </mat-form-field>
                     
                        <mat-form-field class=" col-md-3  form-group " appearance="outline" >
                          <mat-label>Last Name	</mat-label>
                          <input matInput type="text"   name="lastName" autocomplete="off" formControlName="lastName">
                          
                        </mat-form-field>
                        <mat-form-field class=" col-md-3  form-group " appearance="outline">
                          <mat-label>Middle Name	</mat-label>
                          <input matInput type="text"   name="middleName" autocomplete="off"  formControlName="middleName">
          
                        </mat-form-field>
                        <!-- <mat-form-field class=" col-md-3  form-group " appearance="outline">
                          <mat-label>Gender</mat-label>
                          <input matInput type="text"   name="gstAddress" autocomplete="off" >
          
                        </mat-form-field> -->
                       
                        
                        <mat-form-field class="col-md-3 form-group " appearance="outline">
                          <mat-label>Residency	 </mat-label>
                          <input matInput type="text"   name="residencyCountry" autocomplete="off"  formControlName="residencyCountry">

                            <!-- <mat-select  matNativeControl name="company"   formControlName="residencyCountry" >
                             
                            
                  
                            </mat-select> -->
                           </mat-form-field>
                          
                           <mat-form-field class="col-md-3 form-group " appearance="outline">
                            <mat-label> Nationality	 </mat-label>
                            <input matInput type="text"   name="nationality" autocomplete="off"  formControlName="nationality">

                              <!-- <mat-select  matNativeControl name="company"  formControlName="nationality"  >
                               
                              
                    
                              </mat-select> -->
                             </mat-form-field>
                             <mat-form-field class="col-md-3 " appearance="outline">
                              <input matInput [matDatepicker]="pickers" formControlName="dob">
                              <mat-label>Date of Birth</mat-label>
                              <mat-datepicker-toggle matIconSuffix [for]="pickers"></mat-datepicker-toggle>
                              <mat-datepicker #pickers></mat-datepicker>
                          </mat-form-field>
                           
                            <mat-form-field class=" col-md-3  form-group " appearance="outline">
                              <mat-label>Travel Arranger 1</mat-label>
                              <input matInput type="text"  name="arranger2" autocomplete="off" formControlName="travelArranger1">
              
                            </mat-form-field>
                            <mat-form-field class=" col-md-3  form-group " appearance="outline">
                              <mat-label>Travel Arranger 2</mat-label>
                              <input matInput type="text"  name="arranger2" autocomplete="off" formControlName="travelArranger2">
              
                            </mat-form-field>
                           
                            <mat-form-field class=" col-md-3  form-group " appearance="outline">
                              <mat-label>Executive Assistants</mat-label>
                              <input matInput type="text"   name="Executive" autocomplete="off" formControlName="executiveAssistants">
              
                            </mat-form-field>
                            <mat-form-field class=" col-md-3  form-group " appearance="outline">
                              <mat-label>Delegating Supervisor</mat-label>
                              <input matInput type="text"   name="Delegating" autocomplete="off" formControlName="delegatingSupervisor" >
              
                            </mat-form-field>
                            <mat-form-field class=" col-md-3  form-group " appearance="outline">
                              <mat-label>Profile Type	</mat-label>
                              <mat-select name="profile_type" class="wd115" autocomplete="off" formControlName="profileType">
                                <mat-option value="">--</mat-option>
                        <mat-option value="VIP">VIP</mat-option>
                        <mat-option value="VVIP">VVIP/CIP</mat-option>
                        </mat-select>
                            </mat-form-field>
                            
        
                  </form>
                  <div class="d-flex justify-content-end">
                    <button  class="btn btn-outline-success c-width-100px shadow " [disabled]="profileFg.invalid"  (click)="updateProfileUser()">Save</button>
                </div>
                  </div> </div> </div>


                  <div *ngIf="userType" class="outside-container mt-4">
                    <div class="box-container ">
                     <div class="container">
                     <div class="title "> 
                      <div class="row">
                        <div class=" col-md-5 "></div>  
        
                       <div class="col-md-7 d-flex justify-content-start" >Document Information</div>
                      </div>
                    </div>
                    <mat-tab-group mat-stretch-tabs="false" mat-align-tabs="start" class="pb-2 " style="text-align: left;">
                      <mat-tab  label="Passport Details">  
                    <table class="col-md-12 table mt-3 table-sm table-striped table-bordered c-table-hover ml-0 mr-0 mb-0 mt-0"
            style="overflow-y:scroll; width: 100%;min-height: 150px;">
            <thead class="thead-light" >
              <tr>
                <th class="small font-weight-bold w-20 small" style="width: 180px;">Issuing Country</th>

                <th class="small font-weight-bold w-20 small" style="width: 180px;">Number </th>
                <th class="small font-weight-bold w-20 small" style="width: 180px;">Birth Date</th>
                <th class="small font-weight-bold w-40 small" style="width: 180px;" >Issue Date</th>
                <th class="small font-weight-bold w-40 small" style="width: 180px;" >Expiry Date	</th>
                <th class="small font-weight-bold w-40 small" style="width: 180px;" >Issuance Place	</th>
                <th class="small font-weight-bold w-40 small" style="width: 180px;" >Upload	</th>

                <!--<th class="small font-weight-bold w-20 " style="width: 180px;">Gst State Code</th>-->



              </tr>
            </thead>
            <tbody >
            <!--<tr *ngFor="let item of energy.value; let i=index" (dblclick)="dblclick(item)" class="pointer">-->
              <tr  style="height: 25px; " *ngFor="let array of passportArray;let i=index">
                <td class="small  mb-0 mt-0 pl-0 pb-0" >
                  <div class="col-md-12 mt-2 form-group required"  style="z-index: 10;">
                    <p-autoComplete 
           styleClass="col-md-12 "
    [(ngModel)]="array.passportCountry" 
    (ngModelChange)="onCountrySelect($event,array)"

    [dropdown]="false" 
    [suggestions]="filteredUser" 
    (completeMethod)="searchList($event)" 
    field="countryName"
    >
    <ng-template let-user pTemplate="item">
      <div class="flex align-items-start " style="text-align: start;">
          
          <div>{{ user.countryName}}</div>
      </div>
  </ng-template>
</p-autoComplete>
                  
              </div>
            </td>
                <td class="small  mb-0 mt-0 pl-0 pb-0" >

                  <div class="col-md-12 mt-2 mb-1 form-group required" >
                    <input class="form-control" style="height: 49px;" type="text" [(ngModel)]="array.passportNumber" >
                  
                </div>
                </td>
                <td class="small  mb-0 mt-0 pl-0 pb-0" >
                  <div class="col-md-12 mt-2 form-group required" >

                  <input class="form-control" style="height: 49px;" type="date" [(ngModel)]="array.passportDOB">
                  
                </div>

                </td>
                <td class="small  mb-0 mt-0 pl-0 pb-0" >
                  <div class="col-md-12 mt-2 form-group required" appearance="outline">

                  <input  class="form-control" style="height: 49px;" type="date" [(ngModel)]="array.passportDOI">
                  
                </div>

                </td>
                <td class="small  mb-0 mt-0 pl-0 pb-0" >
                  <div class="col-md-12 mt-2 form-group required" appearance="outline">

                  <input class="form-control" style="height: 49px;" type="date" [(ngModel)]="array.passportDOE">
                 
                  </div>

                </td>
               
                <td class="small  mb-0 mt-0 pl-0 pb-0" > 
                  <div class="col-md-12 mt-2 form-group required" appearance="outline">
                  <input class="form-control" style="height: 49px;" type="text"  [(ngModel)]="array.passportPOI">
                
                  </div></td>
                  <td class="small  mb-0 mt-0 pl-0 pb-0 " > 
                    <div *ngIf="isValidPassport(array?.passportNumber)&&array?.id" class="col-md-12 mt-2 form-group required" appearance="outline">
                    <!-- <input class="form-control" style="height: 49px;" accept="image*" type="file"  > -->
                    <button   (click)="ops.toggle($event);" class="btn btn-primary mt-1"  >
                      Upload
                    </button>
                <button *ngIf="array?.passportDocument" (click)="downloadPassport(array?.passportDocument)" class="btn btn-primary mt-1" style="margin-left: 4px;"  >
                  Download
                </button>

                    </div>
                  
                  
                    <p-overlayPanel #ops>
          
                      <span >
                        <!-- <input
                        type="file"
                        accept="image/*"
                        style="display: none"
                        #fileInput
                        (change)="onFileSelected($event,array?.passportNumber)"
                      /> -->
                      
                      <!-- Custom styled button to open file dialog -->
                      <!-- <button class="btn btn-primary " (click)="fileInput.click();"  >
                        Choose Image
                      </button> -->
                      <!-- <p-fileUpload mode="advanced" customUpload="true" (uploadHandler)="onFileSelected($event,array?.passportNumber)"></p-fileUpload> -->
                      <p-fileUpload 
                      mode="advanced"
                      name="myFile"
                      customUpload="true"
                      accept="image/*,application/pdf"
                      [showUploadButton]="true"
                      [showCancelButton]="true"
                      (onSelect)="onFileSelected($event,array?.passportNumber)"
                      (uploadHandler)="upload(ops,array?.passportNumber)">
                    </p-fileUpload>
                   
                    </span>
                        <!-- Save Button -->
                        <!-- <div class="form-actions">
                          <button class="btn btn-primary" (click)="upload(ops,array?.passportNumber)">Save</button>
                        </div> -->
                      
                        
                      
                    </p-overlayPanel>
                  
                  
                  </td>

                <!-- <td class="small  mb-0 mt-0 pl-0 pb-0" >{{item.gstCode}}</td> -->

               
              
       
              </tr>
              
            </tbody>
          </table>
          <div class="col-md-12 row mt-3">
            <div class="col-md-12 d-flex justify-content-end">

<button *ngIf="addPassportButton" mat-flat-button style="color: white;background-color: rgb(6, 110, 245);" (click)="addPassport()">Add Another Passport</button>

  <button *ngIf="clearPassportButton" type="button" style="margin-left: 20px;"  class="close" (click)="clearPassport()">&times;</button>
</div>
</div>
          </mat-tab>
          <mat-tab  label="VISA Details">  


            <table class="col-md-12 mt-3 table table-sm table-striped table-bordered c-table-hover "
            style="overflow-y:scroll; width: 100%;min-height: 150px;">
            <thead class="thead-light" >
              <tr>
                <th class="small font-weight-bold w-20 small" style="width: 180px;">Visa Number </th>

                <th class="small font-weight-bold w-20 small" style="width: 180px;">Issuing Country</th>
                <th class="small font-weight-bold w-20 small" style="width: 180px;">Type of VISA</th>
                <th class="small font-weight-bold w-40 small" style="width: 180px;" >Date of Issue</th>
                <th class="small font-weight-bold w-40 small" style="width: 180px;" >Date of Expiry	</th>
                <th class="small font-weight-bold w-40 small" style="width: 180px;" >Linked Passport	</th>

                <!--<th class="small font-weight-bold w-20 " style="width: 180px;">Gst State Code</th>-->



              </tr>
            </thead>
            <tbody >
            <!--<tr *ngFor="let item of energy.value; let i=index" (dblclick)="dblclick(item)" class="pointer">-->
              <tr  style="height: 25px; " *ngFor="let visaDetail of visaArray">
                
                <td class="small  mb-0 mt-0 pl-0 pb-0" >

                  <div class="col-md-12 mt-2 form-group required" >
                    <input class="form-control"  type="text" style="height: 49px;"  [(ngModel)]="visaDetail.visaNumber" >
                  
                  </div>
                </td>
                <td class="small  mb-0 mt-0 pl-0 pb-0" >
                  <div class="col-md-12 mt-2 form-group required">
                  <p-autoComplete 
           styleClass="col-md-12 "
    [(ngModel)]="visaDetail.issuingCountry" 
    (ngModelChange)="onCountryVisaSelect($event,visaDetail)"

    [dropdown]="false" 
    [suggestions]="filteredUser" 
    (completeMethod)="searchList($event)" 
    field="countryName"
    >
    <ng-template let-user pTemplate="item">
      <div class="flex align-items-start " style="text-align: start;">
          <div>{{ user.countryName}}</div>
      </div>
  </ng-template>
   
  
  
</p-autoComplete>
</div>
            </td>
                <td class="small  mb-0 mt-0 pl-0 pb-0" >
                  <div class="col-md-12 mt-2 form-group required" >

                    <mat-select name="visa_type0" class="form-control" style="height: 49px;"  [(ngModel)]="visaDetail.type" >
                      <mat-option class="mat-primary" value="B">Business</mat-option>
                      <mat-option class="mat-primary" value="T">Tourist</mat-option>
                      <mat-option class="mat-primary" value="W">WorkPermit</mat-option>
                      <mat-option class="mat-primary" value="G">G4</mat-option>
                      <mat-option class="mat-primary" value="S">Student</mat-option>
                      <mat-option class="mat-primary" value="D">Dependent</mat-option>
                      <mat-option class="mat-primary" value="R">Resident</mat-option>
                      <mat-option class="mat-primary" value="M">Migrant</mat-option>
                      <mat-option class="mat-primary" value="E">Employee</mat-option>
                      <mat-option class="mat-primary" value="H">Hajj</mat-option>
                      <mat-option class="mat-primary" value="U">Umrah</mat-option>
                      <mat-option class="mat-primary" value="F">FamilyVisa</mat-option>
                      </mat-select >
                </div>

                </td>
                <td class="small  mb-0 mt-0 pl-0 pb-0" >
                  <div class="col-md-12 mt-2 form-group required" >

                  <input  class="form-control" style="height: 49px;" [(ngModel)]="visaDetail.issueDate" type="date" >
                  
                </div>

                </td>
                <td class="small  mb-0 mt-0 pl-0 pb-0" >
                  <div class="col-md-12 mt-2 form-group required" >

                  <input class="form-control" style="height: 49px;" [(ngModel)]="visaDetail.expiryDate" type="date" >
                  
                </div>

                </td>
               
                <td class="small  mb-0 mt-0 pl-0 pb-0" > 
                  <div class="col-md-12 mt-2 form-group required" >
                  <input class="form-control" style="height: 49px;" [(ngModel)]="visaDetail.name"  type="text" >
                
              </div></td>


               
              
              </tr>
              
            </tbody>
          </table>
          <div class="col-md-12 row mt-3">
            <div class="col-md-6 d-flex justify-content-start">

<button *ngIf="addButton" mat-flat-button style="color: white;background-color: rgb(6, 110, 245);" (click)="addVisa()">Add Another Visa</button>

  <button *ngIf="clearButton" type="button" style="margin-left: 20px;"  class="close" (click)="clear()">&times;</button>
</div>
</div>

</mat-tab>
          </mat-tab-group>
                          <div class="d-flex justify-content-end">
                            <button  class="btn btn-outline-success c-width-100px shadow " (click)="updateProfileUser()">Save</button>
                        </div>
                          </div> </div> </div>
                          <!-- +++++++++++++++++++++++++++++++Frequent Fliers+++++++++++++++++++++++++++++++++++++++ -->
                          <!-- +++++++++++++++++++++++++++++++Frequent Fliers+++++++++++++++++++++++++++++++++++++++ -->
                          <!-- +++++++++++++++++++++++++++++++Frequent Fliers+++++++++++++++++++++++++++++++++++++++ -->
                          <!-- +++++++++++++++++++++++++++++++Frequent Fliers+++++++++++++++++++++++++++++++++++++++ -->
                          <!-- +++++++++++++++++++++++++++++++Frequent Fliers+++++++++++++++++++++++++++++++++++++++ -->



                          <div *ngIf="userType" class="outside-container mt-4">
                            <div class="box-container ">
                             <div class="container">
                             <div class="title "> 
                              <div class="row">
                                <div class=" col-md-5 "></div>  
                
                               <div class="col-md-7 d-flex justify-content-start" >Frequent and Loyality Membership Programs</div>
                              </div>
                            </div>
                            <mat-tab-group mat-stretch-tabs="false" mat-align-tabs="start" class="pb-2" style="text-align: left;">
                            
                  <mat-tab  label="Frequent Fliers">  
        
        
                    <table class="col-md-12 mt-3 table table-sm table-striped table-bordered c-table-hover ml-0 mr-0 mb-0 mt-0"
                    style="overflow-y:scroll;height: auto; width: 100%;">
                    <thead class="thead-light" >
                      <tr>
                        <th class="small font-weight-bold w-20 small" style="width: 180px;">Program</th>
        
                        <th class="small font-weight-bold w-20 small" style="width: 180px;">Membership Number</th>
                        <th class="small font-weight-bold w-20 small" style="width: 180px;">Is Preferred</th>
                        
        
                        <!--<th class="small font-weight-bold w-20 " style="width: 180px;">Gst State Code</th>-->
        
        
        
                      </tr>
                    </thead>
                    <tbody >
                    <!--<tr *ngFor="let item of energy.value; let i=index" (dblclick)="dblclick(item)" class="pointer">-->
                      <tr  style="height: 25px; " *ngFor="let frequentDetail of frequentArray;let i=index">
                        
                        
                        <td class="small mb-0 mt-0 pl-0 pb-0">
                          <mat-form-field class="col-md-12 mt-3 form-group required" appearance="outline">
                            <mat-select-trigger (click)="carrierCodes.open()">
                              <input
                                (input)="carrierCodes.open()"
                                matInput
                                placeholder="Search ..."
                                [(ngModel)]="frequentDetail.searchCarrierQuery"
                                [ngModelOptions]="{standalone: true}"
                                (ngModelChange)="filterCarrier(frequentDetail)"
                              />
                            </mat-select-trigger>
                      
                            <mat-select
                              #carrierCodes="matSelect"
                              matNativeControl
                              name="meal_preference"
                              [(ngModel)]="frequentDetail.Program"
                            >
                              <mat-option
                                *ngFor="let item of frequentDetail.filteredCarrier"
                                [value]="item.airlineDesignatorCode"
                              >
                                {{ item?.carrierName }}, {{ item?.airlineDesignatorCode }}
                              </mat-option>
                            </mat-select>
                          </mat-form-field>
                        </td>
                    <td class="small  mb-0 mt-0 pl-0 pb-0" >
        
                          <mat-form-field class="col-md-12 mt-3 form-group required" appearance="outline">
                            <input matInput type="text"  (keypress)="onlyNumberKey($event)" [(ngModel)]="frequentDetail.number" >
                          
                        </mat-form-field>
                        </td>
                        <td class="small  mb-0 mt-0 pl-0 pb-0" style="text-align: start;padding: 30px;">
                          <input  type="checkbox"  style="width: 20px;height: 20px;cursor: pointer;" [(ngModel)]="frequentDetail.boolean">

        
                        </td>
                        
        
                       
                      
                      </tr>
                      
                    </tbody>
                  </table>
                  <div class="col-md-12 row mt-3">
                    <div class="col-md-6 d-flex justify-content-start">
        
        <button *ngIf="addfrequentButton" mat-flat-button style="color: white;background-color: rgb(6, 110, 245);" (click)="addfrequent()">Add Another Membership</button>
        
        
          <button *ngIf="clearfrequentButton" type="button"   class="close" style="margin-left: 20px;" (click)="frequentClear()">&times;</button>
        </div>
        </div>
        
        </mat-tab>
                  </mat-tab-group>
                                  <div class="d-flex justify-content-end">
                                    <button  class="btn btn-outline-success c-width-100px shadow " (click)="updateProfileUser()">Save</button>
                                </div>
                                  </div> </div> </div>



                          





                                  <div *ngIf="loginUserType==='STAFF'||loginUserType==='CORPORATE'" class="outside-container mt-4">
                                    <div class="box-container ">
                                     <div class="container">
                                     <div class="title "> 
                                      <div class="row">
                                        <div class=" col-md-5  d-flex justify-content-start" style="padding-left:30px;" ></div>  
                                       <div class="col-md-7 d-flex justify-content-start">Extra Commands</div>
                                      </div>
                                    </div>
                                     <form  [formGroup]="profileFg" autocomplete="off"  class=" row mt-4"  >
                                        <div  class="row">
                                      
                                          <div class="col-md-3 form-group">
                                            <mat-form-field appearance="outline" class="w-100">
                                              <mat-label>Queue No</mat-label>
                                              <input matInput formControlName="queueNo" />
                                            </mat-form-field>
                                          </div>
                                      
                                          <div class="col-md-3 form-group">
                                            <mat-form-field appearance="outline" class="w-100">
                                              <mat-label>Owner PCC</mat-label>
                                              <input matInput formControlName="ownerPCC" />
                                            </mat-form-field>
                                          </div>
                                      
                                          <div class="col-md-3 form-group">
                                            <mat-form-field appearance="outline" class="w-100">
                                              <mat-label>Osi</mat-label>
                                              <input matInput formControlName="osi" />
                                            </mat-form-field>
                                          </div>
                                      
                                          <div class="col-md-3 form-group">
                                            <mat-form-field appearance="outline" class="w-100">
                                              <mat-label>Extra Commands</mat-label>
                                              <input matInput formControlName="extraCommands" />
                                            </mat-form-field>
                                          </div>
                                      
                                         
                                      
                                        </div>
                                      
                                
                                          </form>
                                          <div  class="d-flex justify-content-end mt-2">
                                            <button  class="btn btn-outline-success c-width-100px shadow " (click)="updateProfileUser()" >Save</button>
                                        </div>
                                          </div> </div> </div>


<!-- +++++++++++++++++++++++++++++++Preferences+++++++++++++++++++++++++++++++++++++++ -->
<!-- +++++++++++++++++++++++++++++++Preferences+++++++++++++++++++++++++++++++++++++++ -->
<!-- +++++++++++++++++++++++++++++++Preferences+++++++++++++++++++++++++++++++++++++++ -->
<!-- +++++++++++++++++++++++++++++++Preferences+++++++++++++++++++++++++++++++++++++++ -->
<!-- +++++++++++++++++++++++++++++++Preferences+++++++++++++++++++++++++++++++++++++++ -->

                  <div *ngIf="userType" class="outside-container mt-4">
                    <div class="box-container ">
                     <div class="container">
                     <div class="title "> 
                      <div class="row">
                        <div class=" col-md-5 "></div>  
        
                       <div class="col-md-7 d-flex justify-content-start" >Preferences</div>
                      </div>
                    </div>
                     <form  [formGroup]="profileFg" autocomplete="off"  class=" row mt-4"  >
                       
                              <mat-form-field class="  col-md-3 form-group " appearance="outline">
                                <mat-label>Domestic Meal</mat-label>
                                <!-- <input matInput  type="text"   name="titel" autocomplete="off" formControlName="title" > -->
                                <mat-select  matNativeControl name="meal_preference"  formControlName="domMealPref" >
                                    <mat-option value="">--</mat-option>
                                    <mat-option value="VGML">Vegan Veg Meal</mat-option>
                                    <mat-option value="AVML">Hindu Veg Meal</mat-option>
                                    <mat-option value="IVML">Indian Veg Meal</mat-option>
                                    <mat-option value="VJML">Jain Veg Meal</mat-option>
                                    <mat-option value="VLML">Lacto-Ovo Veg Meal</mat-option>
                                    <mat-option value="FPML">Fruit Platter Meal</mat-option>
                                    <mat-option value="NVML">Non-Veg Meal</mat-option>
                                    <mat-option value="MOML">Moslem Meal</mat-option>
                                    <mat-option value="HNML">Hindu Non-Veg Meal</mat-option>
                                    <mat-option value="SFML">Sea Food Meal</mat-option>
                                    <mat-option value="DBML">Diabetic Meal</mat-option>
                                    <mat-option value="NLML">Low Lactose Meal</mat-option>
                                    <mat-option value="CHML">Child Meal</mat-option>
                                    <mat-option value="BBML">Baby Meal</mat-option>
                                    <mat-option value="BLML">Bland Meal</mat-option>
                                    <mat-option value="GFML">Gluten Intolerant Meal</mat-option>
                                    <mat-option value="KSML">Kosher Meal</mat-option>
                                    <mat-option value="LCML">Low Calorie Meal</mat-option>
                                    <mat-option value="LFML">Low Fat Meal</mat-option>
                                    <mat-option value="LSML">Low Salt Meal</mat-option>
                                    <mat-option value="RVML">Vegetarian Raw Meal</mat-option>
                                    <mat-option value="VOML">Vegetarian Oriental Meal</mat-option>
                                    <mat-option value="SPML">Special Meal</mat-option>
                                    <mat-option value="PFML">Peanut Free Meal</mat-option>
                                    <mat-option value="ORML">Oriental Meal</mat-option>
                                    <mat-option value="NSML">No Salt Meal</mat-option>
                                    <mat-option value="PRML">Low Purine Meal</mat-option>
                                    <mat-option value="LPML">Low Protein Meal</mat-option>
                                    <mat-option value="HFML">High Fiber Meal</mat-option>
                                    <mat-option value="NFML">No Fish Meal</mat-option>
        
                               </mat-select>
                              </mat-form-field>
                            
                             
                             
                             
                                <mat-form-field class=" col-md-3  form-group " appearance="outline" >
                                  <mat-label>Domestic Seat	</mat-label>
                                  <mat-select name="seat_preference"  autocomplete="off" formControlName="domSeatPref">
                                    <mat-option value="">--</mat-option>
                                      <mat-option value="NW">Window</mat-option>
                                    <mat-option value="NA">Aisle</mat-option>
                                    <mat-option value="NB">Bulkhead</mat-option>
                                  </mat-select>                                  
                                </mat-form-field>
                                <mat-form-field class=" col-md-3  form-group " appearance="outline">
                                  <mat-label>Domestic Request	</mat-label>
                                     <mat-select name="special_request"  autocomplete="off" formControlName="domSpecialPref">
                                      <mat-option value="">--</mat-option>
                                      <mat-option value="AVIH">Animal In Hold</mat-option>
                                      <mat-option value="BIKE">Bicycle</mat-option>
                                      <mat-option value="BLND">Blind Passenger</mat-option>
                                      <mat-option value="BSCT">Bassinet/Carrycot</mat-option>
                                      <mat-option value="BULK">Bulky Baggage</mat-option>
                                      <mat-option value="CBBG">Cabin Baggage</mat-option>
                                      <mat-option value="CHLD">Child Information</mat-option>
                                      <mat-option value="CKIN">Check in Information</mat-option>
                                      <mat-option value="COUR">Commercial Courier</mat-option>
                                      <mat-option value="DEAF">Deaf Passenger</mat-option>
                                      <mat-option value="DEPA">Deportee (Accompanied)</mat-option>
                                      <mat-option value="DEPU">Deportee (Unaccompanied)</mat-option>
                                      <mat-option value="DPNA">Disabled Passenger Needs</mat-option>
                                      <mat-option value="EPAY">Guaranteed Electronic Payment</mat-option>
                                      <mat-option value="EXST">Extra Seat</mat-option>
                                      <mat-option value="FRAG">Fragile Baggage</mat-option>
                                      <mat-option value="GPST">Group Seat</mat-option>
                                      <mat-option value="GRPF">Group Fare</mat-option>
                                      <mat-option value="INFT">Infant W/O Seat</mat-option>
                                      <mat-option value="LANG">Language Assistance</mat-option>
                                      <mat-option value="MAAS">Meet &amp; Assist</mat-option>
                                      <mat-option value="MEDA">Medical Case</mat-option>
                                      <mat-option value="PETC">Pet In Cabin</mat-option>
                                      <mat-option value="SEMN">Ships Crew</mat-option>
                                      <mat-option value="SLPR">Sleeper/Berth</mat-option>
                                      <mat-option value="SPEQ">Sports Equipment</mat-option>
                                      <mat-option value="STCR">Stretcher</mat-option>
                                      <mat-option value="TKNM">Manual Ticket Number</mat-option>
                                      <mat-option value="TWOV">Transit W/O Visa</mat-option>
                                      <mat-option value="UMNR">Unaccompanied Minor</mat-option>
                                      <mat-option value="WCHC">Wheelchair (Carry On)</mat-option>
                                      <mat-option value="WCHR">Wheelchair (Can Climb Stairs)</mat-option>
                                      <mat-option value="WCHS">Wheelchair (Cannot Climb Stairs)</mat-option>
                                      <mat-option value="WEAP">Weapon Firearm Or Ammunition As Chkd</mat-option>
                                      <mat-option value="XBAG">Excess Baggage</mat-option>
                                      <mat-option value="WCBD">Own Wheelchair- Dry Cell Battery</mat-option>
                                      <mat-option value="WCBW">Own Wheelchair- Wet Cell Battery</mat-option>
                                      <mat-option value="WCOB">Wheelchair Required On Board</mat-option>
                                      <mat-option value="WCMP">Wheelchair Manual Power</mat-option>
                                      <mat-option value="OTHS">Other Information</mat-option>
                                    </mat-select>                  
                                </mat-form-field>
                                <div class="  col-md-3 form-group "  >
                                  <!-- <mat-label>Meal Comment	</mat-label>
                                  <input matInput  type="text"     name="Comment" autocomplete="off"  >
                     -->
                                </div>
                                <!-- <mat-form-field class=" col-md-3  form-group " appearance="outline">
                                  <mat-label>Gender</mat-label>
                                  <input matInput type="text"   name="gstAddress" autocomplete="off" >
                  
                                </mat-form-field> -->
                               
                                
                               
        
                                   <mat-form-field class="col-md-3 form-group " appearance="outline">
                                    <mat-label>International Meal </mat-label>
                                      <mat-select  matNativeControl name="company"   formControlName="intlMealPref" >
                                       
                                       <mat-option value="">--</mat-option>
                                       <mat-option value="VGML">Vegan Veg Meal</mat-option>
                                       <mat-option value="AVML">Hindu Veg Meal</mat-option>
                                       <mat-option value="IVML">Indian Veg Meal</mat-option>
                                       <mat-option value="VJML">Jain Veg Meal</mat-option>
                                       <mat-option value="VLML">Lacto-Ovo Veg Meal</mat-option>
                                       <mat-option value="FPML">Fruit Platter Meal</mat-option>
                                       <mat-option value="NVML">Non-Veg Meal</mat-option>
                                       <mat-option value="MOML">Moslem Meal</mat-option>
                                       <mat-option value="HNML">Hindu Non-Veg Meal</mat-option>
                                       <mat-option value="SFML">Sea Food Meal</mat-option>
                                       <mat-option value="DBML">Diabetic Meal</mat-option>
                                       <mat-option value="NLML">Low Lactose Meal</mat-option>
                                       <mat-option value="CHML">Child Meal</mat-option>
                                       <mat-option value="BBML">Baby Meal</mat-option>
                                       <mat-option value="BLML">Bland Meal</mat-option>
                                       <mat-option value="GFML">Gluten Intolerant Meal</mat-option>
                                       <mat-option value="KSML">Kosher Meal</mat-option>
                                       <mat-option value="LCML">Low Calorie Meal</mat-option>
                                       <mat-option value="LFML">Low Fat Meal</mat-option>
                                       <mat-option value="LSML">Low Salt Meal</mat-option>
                                       <mat-option value="RVML">Vegetarian Raw Meal</mat-option>
                                       <mat-option value="VOML">Vegetarian Oriental Meal</mat-option>
                                       <mat-option value="SPML">Special Meal</mat-option>
                                       <mat-option value="PFML">Peanut Free Meal</mat-option>
                                       <mat-option value="ORML">Oriental Meal</mat-option>
                                       <mat-option value="NSML">No Salt Meal</mat-option>
                                       <mat-option value="PRML">Low Purine Meal</mat-option>
                                       <mat-option value="LPML">Low Protein Meal</mat-option>
                                       <mat-option value="HFML">High Fiber Meal</mat-option>
                                       <mat-option value="NFML">No Fish Meal</mat-option>
                            
                                      </mat-select>
                                     </mat-form-field>
                                     <mat-form-field class="col-md-3 " appearance="outline">
                                      <mat-label>International Seat</mat-label>
                                      <mat-select name="interseat_preference"  autocomplete="off" formControlName="intlSeatPref">
                                        <mat-option value="">--</mat-option>
                                          <mat-option value="NW">Window</mat-option>
                                        <mat-option value="NA">Aisle</mat-option>
                                        <mat-option value="NB">Bulkhead</mat-option>
                                      </mat-select>      
                                  </mat-form-field>
                                   
                                    <mat-form-field class=" col-md-3  form-group " appearance="outline">
                                      <mat-label>International Request</mat-label>
                                      <mat-select name="special_request_international"  autocomplete="off" formControlName="intlSpecialPref">
                                        <mat-option value="">--</mat-option>
                                          <mat-option value="AVIH">Animal In Hold</mat-option>
                                          <mat-option value="BIKE">Bicycle</mat-option>
                                          <mat-option value="BLND">Blind Passenger</mat-option>
                                          <mat-option value="BSCT">Bassinet/Carrycot</mat-option>
                                          <mat-option value="BULK">Bulky Baggage</mat-option>
                                          <mat-option value="CBBG">Cabin Baggage</mat-option>
                                          <mat-option value="CHLD">Child Information</mat-option>
                                          <mat-option value="CKIN">Check in Information</mat-option>
                                          <mat-option value="COUR">Commercial Courier</mat-option>
                                          <mat-option value="DEAF">Deaf Passenger</mat-option>
                                          <mat-option value="DEPA">Deportee (Accompanied)</mat-option>
                                          <mat-option value="DEPU">Deportee (Unaccompanied)</mat-option>
                                          <mat-option value="DPNA">Disabled Passenger Needs</mat-option>
                                          <mat-option value="EPAY">Guaranteed Electronic Payment</mat-option>
                                          <mat-option value="EXST">Extra Seat</mat-option>
                                          <mat-option value="FRAG">Fragile Baggage</mat-option>
                                          <mat-option value="GPST">Group Seat</mat-option>
                                          <mat-option value="GRPF">Group Fare</mat-option>
                                          <mat-option value="INFT">Infant W/O Seat</mat-option>
                                          <mat-option value="LANG">Language Assistance</mat-option>
                                          <mat-option value="MAAS">Meet &amp; Assist</mat-option>
                                          <mat-option value="MEDA">Medical Case</mat-option>
                                          <mat-option value="PETC">Pet In Cabin</mat-option>
                                          <mat-option value="SEMN">Ships Crew</mat-option>
                                          <mat-option value="SLPR">Sleeper/Berth</mat-option>
                                          <mat-option value="SPEQ">Sports Equipment</mat-option>
                                          <mat-option value="STCR">Stretcher</mat-option>
                                          <mat-option value="TKNM">Manual Ticket Number</mat-option>
                                          <mat-option value="TWOV">Transit W/O Visa</mat-option>
                                          <mat-option value="UMNR">Unaccompanied Minor</mat-option>
                                          <mat-option value="WCHC">Wheelchair (Carry On)</mat-option>
                                          <mat-option value="WCHR">Wheelchair (Can Climb Stairs)</mat-option>
                                          <mat-option value="WCHS">Wheelchair (Cannot Climb Stairs)</mat-option>
                                          <mat-option value="WEAP">Weapon Firearm Or Ammunition As Chkd</mat-option>
                                          <mat-option value="XBAG">Excess Baggage</mat-option>
                                          <mat-option value="WCBD">Own Wheelchair- Dry Cell Battery</mat-option>
                                          <mat-option value="WCBW">Own Wheelchair- Wet Cell Battery</mat-option>
                                          <mat-option value="WCOB">Wheelchair Required On Board</mat-option>
                                          <mat-option value="WCMP">Wheelchair Manual Power</mat-option>
                                          <mat-option value="OTHS">Other Information</mat-option>
                                        </mat-select>                      
                                    </mat-form-field>
                                   
                                  
                                    
                
                          </form>
                          <div class="d-flex justify-content-end">
                            <button  class="btn btn-outline-success c-width-100px shadow " (click)="updateProfileUser()">Save</button>
                        </div>
                          </div> </div> </div>


                          <p-dialog 
            header="Tokenized" 
            [modal]="true"
            [(visible)]="visible" 
            [style]="{ width: '50rem',height:'30rem' }" 
            [breakpoints]="{ '1199px': '75vw', '575px': '90vw' }" 
            [maximizable]="true">
            <div class="flex flex-column gap-2 ">
              <label for="enterAmount">Enter CVV</label>
              <input 
              type="text"

                  pInputText 
                  [(ngModel)]="cvv"
                  maxlength="4"
                  aria-describedby="username-help" 
                  (keypress)="onlyNumberKey($event)"
                   />

              <!-- <small >
                 to go to the Payment Page
                 
              </small> -->
          </div>
          <div class="flex flex-column gap-2 ">
            <img src="/assets/images/Add_24.gif" width="350px" height="250px" alt="">

            <button class="stylish-button" (click)="initiatePayment()" [disabled]="!cvv">Tokenized This</button>

          </div>
        </p-dialog>
      </span>